import { CollectionItemType } from '@/types/collection'
import { ENDPOINTS, sendGetRequest, sendPostRequest } from '.'

interface SaveCollectionBody {
  id?: string
  folder_id?: string
  content_id?: string
  name?: string
  properties?: any
}

export async function saveCollection(
  body: SaveCollectionBody
): Promise<string> {
  const { data } = await sendPostRequest(ENDPOINTS.save_collection, body)

  return data.id
}

export async function getCollection<T>(
  id: string
): Promise<CollectionItemType<T> | undefined> {
  try {
    const { data } = await sendPostRequest<{
      msg: { Items: CollectionItemType<T>[] }
    }>(ENDPOINTS.get_collection, { id })

    return data.msg.Items[0]
  } catch (error) {
    console.error('getCollection error:', error)
    return undefined
  }
}

export async function checkCollectionsNotifications(): Promise<boolean> {
  try {
    const { data } = await sendGetRequest<{ has_notifications: boolean }>(
      ENDPOINTS.check_collections_notifications
    )

    return data.has_notifications
  } catch (error) {
    console.error('checkCollectionsNotifications error:', error)
    return false
  }
}

interface FolderAvailableToAdd {
  id: string
  name: string
  folder_id: string
  user_id: string
  level: number
  child: FolderAvailableToAdd[]
}

export async function listFoldersAvailableToAdd(): Promise<
  Array<FolderAvailableToAdd>
> {
  try {
    const { data } = await sendGetRequest(
      ENDPOINTS.list_folders_available_to_add
    )

    return data.Items
  } catch (error) {
    console.error('listFoldersAvailableToAdd error:', error)
  }
}

export async function removeCollectionsNotifications(
  collectionsIds: Array<string>
): Promise<void> {
  try {
    await sendPostRequest(ENDPOINTS.remove_collections_notifications, {
      collections_ids: collectionsIds
    })
  } catch (error) {
    console.error('removeCollectionsNotifications error:', error)
  }
}
